export default __webpack_public_path__ + "static/media/logo.c5d6a3fd.png";